class LazyImage extends HTMLElement {
  constructor() {
    super();

    const lazyImage = this.querySelector('img[data-src]');
    const placeholderImage = this.querySelector('img[data-placeholder]');

    const intersectionObserver = new IntersectionObserver(function(entries) {
      if (entries[0].intersectionRatio <= 0) return;

      if (lazyImage.getAttribute('src')) {
        return;
      }

      lazyImage.addEventListener('load', function() {
        placeholderImage.classList.replace('tw-z-10', 'tw-z-0');
        lazyImage.classList.replace('tw-z-0', 'tw-z-10');
        lazyImage.classList.replace('tw-opacity-0', 'tw-opacity-100');

        setTimeout(() => {
          placeholderImage.classList.add('tw-opacity-0');
        }, 200);
      });

      lazyImage.setAttribute('src', lazyImage.dataset.src);
    });

    if (this.closest('.swiper-wrapper')) {
      intersectionObserver.observe(this.closest('.swiper-wrapper'));
    } else {
      intersectionObserver.observe(placeholderImage);
    }
  }
}

class ProductCard extends HTMLElement {
  constructor() {
    super();

    const swiper = this.querySelector('.swiper');
    const swatches = this.querySelectorAll('.color-swatch');
    const iconText = this.querySelector('.icon-text');
    const infoOverlay = this.querySelector('.info-overlay');

    if (swiper) {
      const interval = setInterval(() => {
        if (window.Swiper) {
          clearInterval(interval);

          new Swiper(swiper, {
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            },
          });
        }
      }, 200);
    }

    swatches.forEach((elem) => {
      elem.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();

        const index = this.dataset.index;

        swiper.swiper.slideTo((index * 2) + 1);

        swatches.forEach((swatch) => {
          if (index === swatch.dataset.index) {
            swatch.classList.replace('tw-border-white', 'tw-border-black');
            swatch.classList.add('tw-z-10');
          } else {
            swatch.classList.replace('tw-border-black', 'tw-border-white');
            swatch.classList.remove('tw-z-10');
          }
        })
      });
    });

    this.querySelector('.tw-group').addEventListener('mouseenter', function() {
      const index = swiper.swiper.activeIndex;

      swiper.swiper.slideTo(index + 1);
    });

    this.querySelector('.tw-group').addEventListener('mouseleave', function() {
      const index = swiper.swiper.activeIndex;

      swiper.swiper.slideTo(index - 1);
    });

    this.querySelectorAll('div[data-icon]').forEach((elem) => {
      const text = elem.dataset.icon;

      elem.addEventListener('mouseenter', function() {
        iconText.innerHTML = text;
      });

      elem.addEventListener('mouseleave', function() {
        iconText.innerHTML = '';
      });
    });

    this.querySelector('.info-open').addEventListener('click', function(e) {
      e.stopPropagation();
      e.preventDefault();

      if (this.closest('.swiper-slide') && window.innerWidth < 1024) {
        const id = this.closest('.swiper-slide').dataset.id;
        const overlay = document.querySelector(`.info-overlay-swiper[data-id="${id}"]`);

        overlay.classList.replace('tw-hidden', 'tw-flex');

        setTimeout(() => {
          overlay.classList.replace('tw-opacity-0', 'tw-opacity-100');
        }, 50);
      } else {
        infoOverlay.classList.replace('tw-hidden', 'tw-flex');

        setTimeout(() => {
          infoOverlay.classList.replace('tw-opacity-0', 'tw-opacity-100');
        }, 50);
      }
    });

    this.querySelector('.info-close').addEventListener('click', function() {
      infoOverlay.classList.replace('tw-opacity-100', 'tw-opacity-0');

      setTimeout(() => {
        infoOverlay.classList.add('tw-hidden');
      }, 200);
    });
  }
}

customElements.define('lazy-image', LazyImage);
customElements.define('product-card', ProductCard);
